'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaLongArrowRight = function FaLongArrowRight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.1 19.9q0 0.3-0.3 0.6l-8.5 7.9q-0.4 0.3-0.8 0.1-0.4-0.2-0.4-0.6v-5h-27.9q-0.3 0-0.5-0.2t-0.2-0.6v-4.2q0-0.4 0.2-0.6t0.5-0.2h27.9v-5q0-0.4 0.4-0.6t0.8 0.1l8.5 7.8q0.3 0.2 0.3 0.5z' })
        )
    );
};

exports.default = FaLongArrowRight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/long-arrow-right.js
// module id = 878
// module chunks = 168707334958949